import sendApiRequest from '../helpers/axios-setup';

export async function getCircularList(
  page,
  limit,
  { filter_batch = '', filter_tag = '', include_deleted = '' } = {},
  sorting_option = 'createdAt$desc'
) {
  try {
    const response = await sendApiRequest.get('/circular', {
      params: {
        page,
        limit,
        filter_batch,
        filter_tag,
        include_deleted,
        sorting_option
      }
    });

    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

export async function getCircularInfo(id) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.get(`/circular/${id}`);
    responseMap.response = response?.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

export async function createCircular(payload) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.post('/circular', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

export async function updateCircular(circularId, payload) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.put(
      `/circular/${circularId}`,
      payload
    );
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

export async function deleteCircular(circularId) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.delete(`/circular/${circularId}`);
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

export async function removeCircularFile(circularId, fileId) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.delete(
      `/circular/${circularId}/file/${fileId}`
    );
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

export async function addCircularFile(circularId, payload) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.post(
      `/circular/${circularId}/file`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    responseMap.response = response.data;
  } catch (e) {
    responseMap.error =
      e?.response?.data?.error || e?.message || 'Something went wrong';
  }

  return responseMap;
}

export async function replaceCircularFiles(circularId, payload) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.put(
      `/circular/${circularId}`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    responseMap.response = response.data;
  } catch (e) {
    responseMap.error =
      e?.response?.data?.error || e?.message || 'Something went wrong';
  }

  return responseMap;
}

export async function publishCircular(circularId) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.post('/circular/publish', null, {
      params: {
        circular: circularId
      }
    });

    responseMap.response = response.data;
  } catch (e) {
    responseMap.error =
      e?.response?.data?.error || e?.message || 'Something went wrong';
  }

  return responseMap;
}

export async function bulkPublishCircular(circularIds) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.post('/circular/bulk-publish', {
      circular: circularIds
    });

    responseMap.response = response.data;
  } catch (e) {
    responseMap.error =
      e?.response?.data?.error || e?.message || 'Something went wrong';
  }

  return responseMap;
}
